module.exports = __webpack_public_path__ + "img/th-list-solid.b39fb484.svg";